import React, {useEffect, useState} from 'react';
import {Alert, Card, CardBody, CardHeader, Col, Container, Input, Row, Spinner} from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
// import ReactApexChart from 'react-apexcharts';
import CountUp from "react-countup";
import {DashboardAPI} from "api"
import {Loading, Utils} from "custom";
import {Link} from "react-router-dom";
import Flatpickr from "react-flatpickr";

import {Italian} from "flatpickr/dist/l10n/it";
import {_, Grid} from "gridjs-react";

import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import logoTikTok from "../../assets/images/logo-tiktok.png";

const moment = require("moment");


const Dashboard = (props) => {
    document.title = "Dashboard | CLTV Cloud";

    const [sessionsCounter, setSessionsCounter] = useState(0);
    const [totalCommissionDev, setTotalCommissionDev] = useState(0);
    /* L'economia su ATOM (22/10/2026, `Utils.economiaSuAtom`): fatturato e provvigioni spariscono,
       restano vendite, clienti nuovi, riconferme, appuntamenti e lead. */
    const senzaSoldi = Utils.economiaSuAtom();

    const [totalRevenueCounter, setTotalRevenueCounter] = useState(0);
    const [totalRevenueEffectiveCounter, setTotalRevenueEffectiveCounter] = useState(0);

    const [totalCommissionCounter, setTotalCommissionCounter] = useState(0);
    const [totalCommissionEffectiveCounter, setTotalCommissionEffectiveCounter] = useState(0);

    const [totalRevenueVideoCounter, setTotalRevenueVideoCounter] = useState(0);
    const [totalRevenueClassroomCounter, setTotalRevenueClassroomCounter] = useState(0);

    const [totalSellVideoCounter, setTotalSellVideoCounter] = useState(0);
    const [totalSellClassroomCounter, setTotalSellClassroomCounter] = useState(0);

    const [newClientRevenueCounter, setNewClientRevenueCounter] = useState(0);
    const [reconfirmRevenueCounter, setReconfirmRevenueCounter] = useState(0);

    const [newClientSellCounter, setNewClientSellCounter] = useState(0);
    const [reconfirmSellCounter, setReconfirmSellCounter] = useState(0);

    const [totLeadsConverted, setTotLeadsConverted] = useState(0);
    const [totLeads, setTotLeads] = useState(0);

    const [appointmentsTotalCounter, setAppointmentsTotalCounter] = useState(0);
    const [appointmentsCompletedCounter, setAppointmentsCompletedCounter] = useState(0);
    const [appointmentsCanceledCounter, setAppointmentsCanceledCounter] = useState(0);
    const [appointmentsConvertedCounter, setAppointmentsConvertedCounter] = useState(0);

    // Dashboard dedicata al consulente: pipeline lead + conversione + prove da confermare + prossimi appuntamenti.
    const [pipeline, setPipeline] = useState(null);
    const [pipelinePercent, setPipelinePercent] = useState(null);
    const [conversionRate, setConversionRate] = useState(0);
    const [courses, setCourses] = useState(null);
    const [upcomingAppointments, setUpcomingAppointments] = useState([]);
    const [loadingConsulent, setLoadingConsulent] = useState(true);

    const [error, setError] = useState(false);

    const [loadingCounters, setLoadingCounters] = useState(true);
    const [loadingConsulents, setLoadingConsulents] = useState(true);
    const [loadingModules, setLoadingModules] = useState(true);

    const [range, setRange] = useState({start_date: moment().startOf("month"), end_date: moment()});

    const [consulents, setConsulents] = useState([]);

    const [modules, setModules] = useState([]);


    useEffect(() => {
        setLoadingCounters(true)
        setLoadingConsulents(true)
        setLoadingModules(true)
        getCounters(range)
    }, [range])


    useEffect(() => {
        if (!loadingCounters)
            if (Utils.getUserData().role === "ADMIN")
                getConsulent(range)
    }, [loadingCounters])

    useEffect(() => {
        if (!loadingConsulents)
            if (Utils.getUserData().role === "ADMIN")
                getModules(range)
    }, [loadingConsulents])

    useEffect(() => {
        if (Utils.getUserData().role === "CONSULENT") {
            setLoadingConsulent(true)
            getConsulentData(range)
        }
    }, [range])

    let getConsulentData = (range) => {
        DashboardAPI.getConsulentDashboard(moment(range.start_date).format("DD-MM-YYYY"), moment(range.end_date).format("DD-MM-YYYY")).then(res => {
            setPipeline(res.pipeline)
            setPipelinePercent(res.pipelinePercent)
            setConversionRate(res.conversionRate)
            setCourses(res.courses)
            setUpcomingAppointments(res.upcomingAppointments)
            setLoadingConsulent(false)
        }).catch((e) => {
            // Un errore su questa sezione aggiuntiva NON deve oscurare l'intera dashboard
            // (i contatori economici restano validi): interrompo solo lo skeleton di questa parte.
            console.error(e)
            setLoadingConsulent(false)
        })
    }

    let getCounters = (range) => {
        setLoadingCounters(true)

        DashboardAPI.getCounters(moment(range.start_date).format("DD-MM-YYYY"), moment(range.end_date).format("DD-MM-YYYY")).then(counters => {

            setSessionsCounter(counters.sessions)
            let totCommissionDev = 0;

            let totRevenue = 0;
            let totRevenueEffective = 0;

            let totCommission = 0;
            let totCommissionEffective = 0;

            let totRevenueVideo = 0;
            let totRevenueClassroom = 0;

            let totSellVideo = 0;
            let totSellClassroom = 0;

            let newClientRevenue = 0;
            let reconfirmRevenue = 0;

            let newClientSell = counters.newClients;
            let reconfirmSell = 0;

            for (let d = 0; d < counters.sells.length; d++) {
                if (counters.sells[d].reconfirm)
                    reconfirmSell = reconfirmSell + 1;

                if (counters.sells[d].type === "VIDEO") {
                    totSellVideo = totSellVideo + 1;
                } else {
                    totSellClassroom = totSellClassroom + 1;
                }
            }

            // Con l'economia su ATOM l'API non manda gli importi (22/10/2026): niente da sommare.
            for (let i = 0; i < (counters.values || []).length; i++) {
                totRevenue = totRevenue + counters.values[i].value
                if (counters.values[i].verified) {
                    totRevenueEffective = totRevenueEffective + counters.values[i].value
                    totCommissionEffective = totCommissionEffective + counters.values[i].commission
                }

                totCommissionDev = totCommissionDev + counters.values[i].commissionDev
                totCommission = totCommission + counters.values[i].commission

                if (counters.values[i].type === "VIDEO") {
                    totRevenueVideo = totRevenueVideo + counters.values[i].value
                } else {
                    totRevenueClassroom = totRevenueClassroom + counters.values[i].value
                }

                if (counters.values[i].reconfirm) {
                    reconfirmRevenue = reconfirmRevenue + counters.values[i].value
                } else {
                    newClientRevenue = newClientRevenue + counters.values[i].value
                }
            }

            setTotalCommissionDev(totCommissionDev);

            setTotalRevenueCounter(totRevenue);
            setTotalRevenueEffectiveCounter(totRevenueEffective);

            setTotalCommissionCounter(totCommission);
            setTotalCommissionEffectiveCounter(totCommissionEffective);

            setTotalRevenueVideoCounter(totRevenueVideo);
            setTotalRevenueClassroomCounter(totRevenueClassroom);

            setTotalSellVideoCounter(totSellVideo);
            setTotalSellClassroomCounter(totSellClassroom);

            setNewClientRevenueCounter(newClientRevenue);
            setReconfirmRevenueCounter(reconfirmRevenue);

            setNewClientSellCounter(newClientSell);
            setReconfirmSellCounter(reconfirmSell);

            setAppointmentsTotalCounter(counters.appointments.totals)
            setAppointmentsCompletedCounter(counters.appointments.completed)
            setAppointmentsCanceledCounter(counters.appointments.canceled)
            setAppointmentsConvertedCounter(counters.appointments.converted)

            setLoadingCounters(false);

        }).catch((e) => {
            console.error(e)
            setError(true)
        })
    }


    let getConsulent = (range) => {
        setLoadingConsulents(true)

        DashboardAPI.getConsulents(moment(range.start_date).format("DD-MM-YYYY"), moment(range.end_date).format("DD-MM-YYYY")).then(res => {

            let resConsulents = [];
            for (let i = 0; i < res.length; i++) {
                let revenue = 0;
                let commission = 0;
                let revenueClassroom = 0;
                let revenueVideo = 0;
                let newClients = res[i].newClients;
                let reconfirms = res[i].sellsReconfirm;
                let sellClassroom = res[i].sellsClassroom;
                let sellVideo = res[i].sellsVideo;

                // let idsNewClients = [];

                for (let d = 0; d < res[i].sells.length; d++) {

                    // if (res[i].sells[d].type === "VIDEO")
                    //     sellVideo = sellVideo + 1;
                    //
                    // if (res[i].sells[d].type === "CLASSROOM")
                    //     sellClassroom = sellClassroom + 1;

                    for (let c = 0; c < (res[i].sells[d].payments || []).length; c++) {
                        revenue = revenue + res[i].sells[d].payments[c].value
                        commission = commission + res[i].sells[d].payments[c].commission

                        if (res[i].sells[d].type === "VIDEO")
                            revenueVideo = revenueVideo + res[i].sells[d].payments[c].value;

                        if (res[i].sells[d].type === "CLASSROOM")
                            revenueClassroom = revenueClassroom + res[i].sells[d].payments[c].value;
                    }
                }

                resConsulents.push({
                    id: res[i].id,
                    name: res[i].name,
                    revenue: revenue,
                    commission: commission,
                    revenueClassroom: revenueClassroom,
                    revenueVideo: revenueVideo,
                    newClients: newClients,
                    reconfirms: reconfirms,
                    sellClassroom: sellClassroom,
                    sellVideo: sellVideo,
                    appointments: res[i].appointments,
                    appointmentsConverted: res[i].appointmentsConverted,
                    leads: res[i].leads.length,
                    leadsConverted: res[i].leads.filter((l) => l.converted).length
                })
            }
            setConsulents(resConsulents)
            setLoadingConsulents(false)
        }).catch((e) => {
            console.error(e)
            setError(true)
        })

    }


    let getReferralDetail = (referral) => {
        switch(referral.name) {
            case "META":
                return {
                    ...referral,
                    name: "META",
                    icon: "ri-facebook-box-fill align-middle fs-20 text-secondary"
                }
            case "FUNNEL":
                return {
                    ...referral,
                    name: "FUNNEL",
                    icon: "ri-global-fill align-middle fs-20 text-primary"
                }
            case "WHATSAPP":
                return {
                    ...referral,
                    name: "WHATSAPP",
                    icon: "ri-whatsapp-fill align-middle fs-20 text-success"
                }
            case "MANUAL":
                return {
                    ...referral,
                    name: "MANUALE/PASSAPAROLA",
                    icon: "ri-git-repository-commits-fill align-middle fs-20 text-info"
                }
            case "REPORT":
                return {
                    ...referral,
                    name: "SEGNALAZIONI",
                    icon: "mdi mdi-bullhorn align-middle fs-20 text-danger"
                }
            case "TIK_TOK":
                return {
                    ...referral,
                    name: "TIK TOK",
                    icon: ""
                }
            default:
                return null;
        }
    }

    let getModules = (range) => {
        setLoadingModules(true)
        DashboardAPI.getModules(moment(range.start_date).format("DD-MM-YYYY"), moment(range.end_date).format("DD-MM-YYYY")).then(res => {
            setTotLeads(res.counterLeads)
            setTotLeadsConverted(res.counterConverted)
            setModules(res.list.map((r) => getReferralDetail(r)))
            setLoadingModules(false)
        }).catch((e) => {
            console.error(e)
            setError(true)
        })

    }


    if (error) {
        return <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Dashboard" pageTitle="CLTV Cloud"/>
                    <div className="row">
                        <Alert color="danger">Si è verificato un errore durante il recupero della dashboard.</Alert>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Dashboard" pageTitle="CLTV Cloud"/>
                    <div>
                        <Row className="mb-3 pb-1">
                            <Col xs={12}>
                                <div className="d-flex align-items-lg-center flex-lg-row flex-column">
                                    <div className="flex-grow-1">
                                        <h4 className="fs-16 mb-1">Hallo, {Utils.getUserData().firstname}!</h4>
                                        <p className="text-muted mb-0">Vediamo come sta andando il tuo andamento!</p>
                                    </div>
                                    <div className="mt-3 mt-lg-0">
                                        <form action="#">
                                            <Row className="g-3 mb-0 align-items-center">
                                                <div className="col-sm-auto">
                                                    <div className="input-group">
                                                        <Flatpickr
                                                            className="form-control border-0 dash-filter-picker shadow"
                                                            options={{
                                                                mode: "range",
                                                                dateFormat: "d/m/Y",
                                                                locale: Italian,
                                                            }}
                                                            value={[range.start_date.format("DD/MM/YYYY"), range.end_date.format("DD/MM/YYYY")]}
                                                            onChange={(selectedDates) => {
                                                                if (selectedDates.length === 2) {
                                                                    setRange({
                                                                        start_date: moment(selectedDates[0]),
                                                                        end_date: moment(selectedDates[1]),
                                                                    });
                                                                }
                                                            }}
                                                        />
                                                        <div
                                                            className="input-group-text bg-primary border-primary text-white">
                                                            <i className="ri-calendar-2-line"></i></div>
                                                    </div>
                                                </div>
                                            </Row>
                                        </form>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        {(Utils.getUserData().role === "CONSULENT") ?
                            <h5 className="fs-15 mb-3"><i className="ri-money-euro-circle-line me-1 text-success"></i> I tuoi numeri</h5> : null}
                        <Row>
                            {(totalCommissionDev > 0 && Utils.getUserData().role === "ADMIN") ? <p><b>Mantenimento
                                Piattaforma: {Utils.getValueMoneyLabel(totalCommissionDev)}</b>
                            </p> : null}<br/>
                            {(Utils.getUserData().role === "ADMIN") ?
                                <p><b>Utenti Attivi: {sessionsCounter}</b></p> : null}
                            <Row>
                                {!senzaSoldi ? (
                                <Col md={6} xl={3}>
                                    <Card>
                                        <CardBody>
                                            {(loadingCounters) ? <Skeleton height={45}/> :
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-light text-primary rounded-circle fs-3">
                                                    <i className={"align-middle bx bx-euro"}></i>
                                                </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">FATTURATO
                                                            STIMATO</p>
                                                        <h4 className=" mb-0">
                                                            <CountUp
                                                                suffix=""
                                                                prefix="€"
                                                                decimal=","
                                                                separator="."
                                                                start={0}
                                                                decimals={2}
                                                                end={totalRevenueCounter}
                                                                duration={3}
                                                            />
                                                        </h4>
                                                    </div>
                                                </div>}
                                        </CardBody>
                                    </Card>
                                </Col>
                                ) : null}
                                {!senzaSoldi ? (
                                <Col md={6} xl={3}>
                                    <Card>
                                        <CardBody>
                                            {(loadingCounters) ? <Skeleton height={45}/> :
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-light text-success rounded-circle fs-3">
                                                    <i className={"align-middle bx bx-euro"}></i>
                                                </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">FATTURATO
                                                            EFFETTIVO</p>
                                                        <h4 className=" mb-0">
                                                            <CountUp
                                                                suffix=""
                                                                prefix="€"
                                                                decimal=","
                                                                separator="."
                                                                start={0}
                                                                decimals={2}
                                                                end={totalRevenueEffectiveCounter}
                                                                duration={3}
                                                            />
                                                        </h4>
                                                    </div>
                                                </div>}
                                        </CardBody>
                                    </Card>
                                </Col>
                                ) : null}
                                {!senzaSoldi ? (
                                <Col md={6} xl={3}>
                                    <Card>
                                        <CardBody>
                                            {(loadingCounters) ? <Skeleton height={45}/> :
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-light text-primary rounded-circle fs-3">
                                                    <i className="align-middle mdi mdi-wallet"></i>
                                                </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">PROVVIGIONI
                                                            STIMATE</p>
                                                        <h4 className=" mb-0">
                                                            <CountUp
                                                                suffix=""
                                                                prefix="€"
                                                                decimal=","
                                                                separator="."
                                                                start={0}
                                                                decimals={0}
                                                                end={totalCommissionCounter}
                                                                duration={3}
                                                            />
                                                        </h4>
                                                    </div>
                                                </div>}
                                        </CardBody>
                                    </Card>
                                </Col>
                                ) : null}
                                {!senzaSoldi ? (
                                <Col md={6} xl={3}>
                                    <Card>
                                        <CardBody>
                                            {(loadingCounters) ? <Skeleton height={45}/> :
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-light text-success rounded-circle fs-3">
                                                    <i className="align-middle mdi mdi-wallet"></i>
                                                </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">PROVVIGIONI
                                                            EFFETTIVE</p>
                                                        <h4 className=" mb-0">
                                                            <CountUp
                                                                suffix=""
                                                                prefix="€"
                                                                decimal=","
                                                                separator="."
                                                                start={0}
                                                                decimals={0}
                                                                end={totalCommissionEffectiveCounter}
                                                                duration={3}
                                                            />
                                                        </h4>
                                                    </div>
                                                </div>}
                                        </CardBody>
                                    </Card>
                                </Col>
                                ) : null}
                            </Row>
                            <Row>
                                {!senzaSoldi ? (
                                <Col md={6} xl={3}>
                                    <Card>
                                        <CardBody>
                                            {(loadingCounters) ? <Skeleton height={45}/> :
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-light text-primary rounded-circle fs-3">
                                                    <i className="align-middle bx bx-video"></i>
                                                </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">FATT.
                                                            VIDEO</p>
                                                        <h4 className=" mb-0">
                                                            <CountUp
                                                                suffix=""
                                                                prefix="€"
                                                                decimal=","
                                                                separator="."
                                                                start={0}
                                                                decimals={2}
                                                                end={totalRevenueVideoCounter}
                                                                duration={3}
                                                            />
                                                        </h4>
                                                    </div>
                                                </div>}
                                        </CardBody>
                                    </Card>
                                </Col>
                                ) : null}
                                {!senzaSoldi ? (
                                <Col md={6} xl={3}>
                                    <Card>
                                        <CardBody>
                                            {(loadingCounters) ? <Skeleton height={45}/> :
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-light text-primary rounded-circle fs-3">
                                                    <i className="align-middle mdi mdi-school"></i>
                                                </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">FATT.
                                                            CLASSI</p>
                                                        <h4 className=" mb-0">
                                                            <CountUp
                                                                suffix=""
                                                                prefix="€"
                                                                decimal=","
                                                                separator="."
                                                                start={0}
                                                                decimals={2}
                                                                end={totalRevenueClassroomCounter}
                                                                duration={3}
                                                            />
                                                        </h4>
                                                    </div>
                                                </div>}
                                        </CardBody>
                                    </Card>
                                </Col>
                                ) : null}
                                <Col md={6} xl={3}>
                                    <Card>
                                        <CardBody>
                                            {(loadingCounters) ? <Skeleton height={45}/> :
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-light text-primary rounded-circle fs-3">
                                                    <i className="align-middle bx bx-video"></i>
                                                </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">VENDITE
                                                            VIDEO</p>
                                                        <h4 className=" mb-0">
                                                            <CountUp
                                                                suffix=""
                                                                prefix=""
                                                                decimal=""
                                                                separator="."
                                                                start={0}
                                                                decimals={0}
                                                                end={totalSellVideoCounter}
                                                                duration={3}
                                                            />
                                                        </h4>
                                                    </div>
                                                </div>}
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col md={6} xl={3}>
                                    <Card>
                                        <CardBody>
                                            {(loadingCounters) ? <Skeleton height={45}/> :
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-light text-primary rounded-circle fs-3">
                                                    <i className="align-middle mdi mdi-school"></i>
                                                </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">VENDITE
                                                            CLASSI</p>
                                                        <h4 className=" mb-0">
                                                            <CountUp
                                                                suffix=""
                                                                prefix=""
                                                                decimal=""
                                                                separator="."
                                                                start={0}
                                                                decimals={0}
                                                                end={totalSellClassroomCounter}
                                                                duration={3}
                                                            />
                                                        </h4>
                                                    </div>
                                                </div>}
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                            <Row>
                                {!senzaSoldi ? (
                                <Col md={6} xl={3}>
                                    <Card>
                                        <CardBody>
                                            {(loadingCounters) ? <Skeleton height={45}/> :
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-light text-primary rounded-circle fs-3">
                                                    <i className="align-middle mdi mdi-account-multiple-plus"></i>
                                                </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">FATT.
                                                            NUOVI ISCRITTI</p>
                                                        <h4 className=" mb-0">
                                                            <CountUp
                                                                suffix=""
                                                                prefix="€"
                                                                decimal=","
                                                                separator="."
                                                                start={0}
                                                                decimals={2}
                                                                end={newClientRevenueCounter}
                                                                duration={3}
                                                            />
                                                        </h4>
                                                    </div>
                                                </div>}
                                        </CardBody>
                                    </Card>
                                </Col>
                                ) : null}
                                {!senzaSoldi ? (
                                <Col md={6} xl={3}>
                                    <Card>
                                        <CardBody>
                                            {(loadingCounters) ? <Skeleton height={45}/> :
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-light text-primary rounded-circle fs-3">
                                                    <i className="align-middle mdi mdi-account-check"></i>
                                                </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">FATT.
                                                            RICONFERME</p>
                                                        <h4 className=" mb-0">
                                                            <CountUp
                                                                suffix=""
                                                                prefix="€"
                                                                decimal=","
                                                                separator="."
                                                                start={0}
                                                                decimals={2}
                                                                end={reconfirmRevenueCounter}
                                                                duration={3}
                                                            />
                                                        </h4>
                                                    </div>
                                                </div>}
                                        </CardBody>
                                    </Card>
                                </Col>
                                ) : null}
                                <Col md={6} xl={3}>
                                    <Card>
                                        <CardBody>
                                            {(loadingCounters) ? <Skeleton height={45}/> :
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-light text-primary rounded-circle fs-3">
                                                    <i className="align-middle mdi mdi-account-multiple-plus"></i>
                                                </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">NUOVI
                                                            ISCRITTI</p>
                                                        <h4 className=" mb-0">
                                                            <CountUp
                                                                suffix=""
                                                                prefix=""
                                                                decimal=","
                                                                separator="."
                                                                start={0}
                                                                decimals={0}
                                                                end={newClientSellCounter}
                                                                duration={3}
                                                            />
                                                        </h4>
                                                    </div>
                                                </div>}
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col md={6} xl={3}>
                                    <Card>
                                        <CardBody>
                                            {(loadingCounters) ? <Skeleton height={45}/> :
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-light text-primary rounded-circle fs-3">
                                                    <i className="align-middle mdi mdi-account-check"></i>
                                                </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">RICONFERME</p>
                                                        <h4 className=" mb-0">
                                                            <CountUp
                                                                suffix=""
                                                                prefix=""
                                                                decimal=""
                                                                separator="."
                                                                start={0}
                                                                decimals={0}
                                                                end={reconfirmSellCounter}
                                                                duration={3}
                                                            />
                                                        </h4>
                                                    </div>
                                                </div>}
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6} xl={3}>
                                    <Card>
                                        <CardBody>
                                            {(loadingCounters) ? <Skeleton height={45}/> :
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-light text-primary rounded-circle fs-3">
                                                    <i className="align-middle mdi mdi-calendar-blank"></i>
                                                </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">APPUNTAMENTI FISSATI</p>
                                                        <h4 className=" mb-0">
                                                            <CountUp
                                                                suffix=""
                                                                prefix=""
                                                                decimal=","
                                                                separator="."
                                                                start={0}
                                                                decimals={0}
                                                                end={appointmentsTotalCounter}
                                                                duration={3}
                                                            />
                                                        </h4>
                                                    </div>
                                                </div>}
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col md={6} xl={3}>
                                    <Card>
                                        <CardBody>
                                            {(loadingCounters) ? <Skeleton height={45}/> :
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-light text-primary rounded-circle fs-3">
                                                    <i className="align-middle mdi mdi-calendar-check"></i>
                                                </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">APPUNTAMENTI COMPLETATI</p>
                                                        <h4 className=" mb-0">
                                                            <CountUp
                                                                suffix=""
                                                                prefix=""
                                                                decimal=","
                                                                separator="."
                                                                start={0}
                                                                decimals={0}
                                                                end={appointmentsCompletedCounter}
                                                                duration={3}
                                                            />
                                                        </h4>
                                                    </div>
                                                </div>}
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col md={6} xl={3}>
                                    <Card>
                                        <CardBody>
                                            {(loadingCounters) ? <Skeleton height={45}/> :
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-light text-primary rounded-circle fs-3">
                                                    <i className="align-middle mdi mdi-calendar-alert text-danger"></i>
                                                </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">APPUNTAMENTI ANNULLATI</p>
                                                        <h4 className=" mb-0">
                                                            <CountUp
                                                                suffix=""
                                                                prefix=""
                                                                decimal=","
                                                                separator="."
                                                                start={0}
                                                                decimals={0}
                                                                end={appointmentsCanceledCounter}
                                                                duration={3}
                                                            />
                                                        </h4>
                                                    </div>
                                                </div>}
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col md={6} xl={3}>
                                    <Card>
                                        <CardBody>
                                            {(loadingCounters) ? <Skeleton height={45}/> :
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-light text-primary rounded-circle fs-3">
                                                    <i className="align-middle mdi mdi-calendar-check text-success"></i>
                                                </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">APPUNTAMENTI CONVERTITI</p>
                                                        <h4 className=" mb-0">
                                                            <CountUp
                                                                suffix=""
                                                                prefix=""
                                                                decimal=""
                                                                separator="."
                                                                start={0}
                                                                decimals={0}
                                                                end={appointmentsConvertedCounter}
                                                                duration={3}
                                                            />
                                                        </h4>
                                                    </div>
                                                </div>}
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </Row>
                        {(Utils.getUserData().role === "CONSULENT") ?
                            <div className="mb-2 mt-2">
                                <hr className="mt-1 mb-3"/>
                                <h5 className="fs-15 mb-3"><i className="ri-flow-chart me-1 text-primary"></i> La tua pipeline lead</h5>
                                <Row>
                                    {[
                                        {label: "Lead assegnati", value: pipeline ? pipeline.assigned : 0, icon: "bx bx-user-plus", color: "primary"},
                                        {label: "In lavorazione", value: pipeline ? pipeline.working : 0, icon: "bx bx-loader-circle", color: "info", pctKey: "working"},
                                        {label: "In prova", value: pipeline ? pipeline.trial : 0, icon: "bx bx-test-tube", color: "warning", pctKey: "trial"},
                                        {label: "Da richiamare", value: pipeline ? pipeline.appointment : 0, icon: "bx bx-phone-call", color: "secondary", pctKey: "appointment"},
                                        {label: "Convertiti", value: pipeline ? pipeline.converted : 0, icon: "bx bx-check-circle", color: "success", pctKey: "converted"},
                                        {label: "Conversione", value: conversionRate, icon: "bx bx-trending-up", color: "success", suffix: "%"}
                                    ].map((c, i) =>
                                        <Col md={4} xl={2} key={i}>
                                            <Card>
                                                <CardBody className="py-3">
                                                    {(loadingConsulent) ? <Skeleton height={40}/> :
                                                        <div className="d-flex align-items-center">
                                                            <div className="avatar-xs flex-shrink-0">
                                                                <span className={"avatar-title bg-light text-" + c.color + " rounded-circle fs-4"}>
                                                                    <i className={"align-middle " + c.icon}></i>
                                                                </span>
                                                            </div>
                                                            <div className="flex-grow-1 ms-2">
                                                                <p className="text-uppercase fw-semibold fs-11 text-muted mb-1">{c.label}</p>
                                                                <h4 className="mb-0 fs-18">
                                                                    <CountUp start={0} end={c.value || 0} decimals={(c.suffix === "%") ? 1 : 0} duration={2}/>{c.suffix || ""}
                                                                </h4>
                                                                {(c.pctKey && pipelinePercent) ?
                                                                    <small className="text-muted">{pipelinePercent[c.pctKey]}% del totale</small> : null}
                                                            </div>
                                                        </div>}
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    )}
                                </Row>
                                <Row>
                                    <Col xl={12}>
                                        <Card>
                                            <CardHeader className="d-flex align-items-center">
                                                <h6 className="card-title mb-0 flex-grow-1"><i className="ri-calendar-event-line me-1"></i> Prossimi appuntamenti</h6>
                                            </CardHeader>
                                            <CardBody>
                                                {(loadingConsulent) ? <Skeleton height={120}/> :
                                                    (upcomingAppointments.length === 0) ?
                                                        <p className="text-muted mb-0">Nessun appuntamento in programma.</p> :
                                                        <div className="table-responsive">
                                                            <table className="table table-borderless table-sm align-middle mb-0">
                                                                <tbody>
                                                                {upcomingAppointments.map((a) =>
                                                                    <tr key={a.id}>
                                                                        <td>
                                                                            <Link to={"/lead/detail/" + a.id_lead} className="text-body fw-medium">{Utils.leadName(a.name)}</Link>
                                                                        </td>
                                                                        <td className="text-nowrap">
                                                                            <i className="ri-time-line me-1 text-muted"></i>{moment(a.date_hour).format("DD/MM/YYYY HH:mm")}
                                                                        </td>
                                                                        <td className="text-end">
                                                                            <span className={"badge " + ((a.status === "CONFIRMED") ? "bg-success-subtle text-success" : "bg-secondary-subtle text-secondary")}>
                                                                                {(a.status === "CONFIRMED") ? "Confermato" : "Da confermare"}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                                </tbody>
                                                            </table>
                                                        </div>}
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <hr className="mt-1 mb-3"/>
                                <h5 className="fs-15 mb-3"><i className="ri-book-open-line me-1 text-info"></i> Corsi venduti nel periodo</h5>
                                <Row>
                                    <Col md={6} xl={3}>
                                        <Card>
                                            <CardBody className="py-3">
                                                {(loadingConsulent) ? <Skeleton height={45}/> :
                                                    <div className="d-flex align-items-center">
                                                        <div className="avatar-sm flex-shrink-0">
                                                            <span className="avatar-title bg-light text-primary rounded-circle fs-3"><i className="bx bx-play-circle"></i></span>
                                                        </div>
                                                        <div className="flex-grow-1 ms-3">
                                                            <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">Vendite Video</p>
                                                            <h4 className="mb-0"><CountUp start={0} end={courses ? courses.video.count : 0} duration={2}/></h4>
                                                            {!senzaSoldi ? <small className="text-muted">{Utils.getValueMoneyLabel(courses ? courses.video.revenue : 0)}</small> : null}
                                                        </div>
                                                    </div>}
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={6} xl={3}>
                                        <Card>
                                            <CardBody className="py-3">
                                                {(loadingConsulent) ? <Skeleton height={45}/> :
                                                    <div className="d-flex align-items-center">
                                                        <div className="avatar-sm flex-shrink-0">
                                                            <span className="avatar-title bg-light text-info rounded-circle fs-3"><i className="bx bx-group"></i></span>
                                                        </div>
                                                        <div className="flex-grow-1 ms-3">
                                                            <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">Vendite Classi</p>
                                                            <h4 className="mb-0"><CountUp start={0} end={courses ? courses.classroom.count : 0} duration={2}/></h4>
                                                            {!senzaSoldi ? <small className="text-muted">{Utils.getValueMoneyLabel(courses ? courses.classroom.revenue : 0)}</small> : null}
                                                        </div>
                                                    </div>}
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col xl={6}>
                                        <Card>
                                            <CardHeader className="py-2"><h6 className="card-title mb-0">Dettaglio per corso / livello</h6></CardHeader>
                                            <CardBody className="py-2">
                                                {(loadingConsulent) ? <Skeleton height={100}/> :
                                                    (!courses || courses.breakdown.length === 0) ?
                                                        <p className="text-muted mb-0">Nessuna vendita nel periodo.</p> :
                                                        <div className="table-responsive">
                                                            <table className="table table-sm table-borderless align-middle mb-0">
                                                                <tbody>
                                                                {courses.breakdown.map((b, i) =>
                                                                    <tr key={i}>
                                                                        <td>
                                                                            <span className={"badge me-2 " + ((b.type === "VIDEO") ? "bg-primary-subtle text-primary" : "bg-info-subtle text-info")}>{(b.type === "VIDEO") ? "Video" : "Classe"}</span>
                                                                            {b.label}
                                                                        </td>
                                                                        <td className="text-center text-nowrap text-muted">{b.count} vend.</td>
                                                                        {!senzaSoldi ? <td className="text-end fw-medium text-nowrap">{Utils.getValueMoneyLabel(b.revenue)}</td> : null}
                                                                    </tr>
                                                                )}
                                                                </tbody>
                                                            </table>
                                                        </div>}
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </div> : null}
                        {(Utils.getUserData().role === "ADMIN") ? <Row>
                            <Col>
                                <Card>
                                    <CardHeader>
                                        <h5 className="card-title">Statistiche Consulenti</h5>
                                    </CardHeader>
                                    <CardBody>
                                        {(loadingConsulents) ? <div className="mt-1">
                                            <Skeleton height={50}/><br/>
                                            <Skeleton height={50}/><br/>
                                            <Skeleton height={50}/><br/>
                                            <Skeleton height={50}/><br/>
                                            <Skeleton height={50}/><br/>
                                            <Skeleton height={50}/><br/>
                                            <Skeleton height={50}/><br/>
                                            <Skeleton height={50}/><br/>
                                            <Skeleton height={50}/>
                                        </div> : <Grid
                                            data={consulents.sort((a, b) => b.revenue - a.revenue)}
                                            columns={[
                                                {
                                                    id: 'name',
                                                    name: 'Nome',
                                                    formatter: (cell, row) => _(
                                                        <div className="text-nowrap"><b>{cell}</b></div>
                                                    ),
                                                },
                                                {
                                                    id: 'revenue',
                                                    hidden: senzaSoldi,
                                                    name: 'Fatturato',
                                                    formatter: (cell, row) => _(
                                                        <div className="text-nowrap text-center">
                                                            <b>{Utils.getValueMoneyLabel(cell)}</b><br/><small
                                                            hidden={!isFinite(cell * 100 / totalRevenueCounter)}>{Math.round(cell * 100 / totalRevenueCounter)} %</small>
                                                        </div>
                                                    ),
                                                },
                                                {
                                                    id: 'commission',
                                                    hidden: senzaSoldi,
                                                    name: 'Provvigioni',
                                                    formatter: (cell, row) => _(
                                                        <div
                                                            className="text-nowrap text-center">{Utils.getValueMoneyLabel(cell)}</div>
                                                    ),
                                                },
                                                {
                                                    id: 'revenueClassroom',
                                                    hidden: senzaSoldi,
                                                    name: 'Fatturato Classi',
                                                    formatter: (cell, row) => _(
                                                        <div
                                                            className="text-nowrap text-center">{Utils.getValueMoneyLabel(cell)}</div>
                                                    ),
                                                },
                                                {
                                                    id: 'revenueVideo',
                                                    hidden: senzaSoldi,
                                                    name: 'Fatturato Video',
                                                    formatter: (cell, row) => _(
                                                        <div
                                                            className="text-nowrap text-center">{Utils.getValueMoneyLabel(cell)}</div>
                                                    ),
                                                },
                                                {
                                                    id: 'appointments',
                                                    name: 'Appuntamenti',
                                                    formatter: (cell, row) => _(
                                                        <div className="text-nowrap text-center">{cell}</div>
                                                    ),
                                                    width: '50px'
                                                },
                                                {
                                                    id: 'appointmentsConverted',
                                                    name: 'Appuntamenti convertiti',
                                                    formatter: (cell, row) => _(
                                                        <div className="text-nowrap text-center">{cell}<br/><small
                                                            hidden={!isFinite(cell * 100 / row.cells[5].data)}>{Math.round(cell * 100 / row.cells[5].data)} %</small>
                                                        </div>
                                                    ),
                                                    width: '50px'
                                                },
                                                {
                                                    id: 'newClients',
                                                    name: 'Nuovi Iscritti',
                                                    formatter: (cell, row) => _(
                                                        <div className="text-nowrap text-center">{cell}</div>
                                                    ),
                                                    width: '50px'
                                                },
                                                {
                                                    id: 'reconfirms',
                                                    name: 'Riconferme',
                                                    formatter: (cell, row) => _(
                                                        <div className="text-nowrap text-center">{cell}</div>
                                                    ),
                                                    width: '50px'
                                                },
                                                {
                                                    id: 'sellClassroom',
                                                    name: 'Vendite Classi',
                                                    formatter: (cell, row) => _(
                                                        <div className="text-nowrap text-center">{cell}</div>
                                                    ),
                                                    width: '50px'
                                                },
                                                {
                                                    id: 'sellVideo',
                                                    name: 'Vendite Video',
                                                    formatter: (cell, row) => _(
                                                        <div className="text-nowrap text-center">{cell}</div>
                                                    ),
                                                    width: '50px'
                                                },
                                                {
                                                    id: 'leads',
                                                    name: 'Leads',
                                                    formatter: (cell, row) => _(
                                                        <div className="text-nowrap text-center">{cell}</div>
                                                    ),
                                                    width: '50px'
                                                },
                                                {
                                                    id: 'leadsConverted',
                                                    name: 'Leads convertiti',
                                                    formatter: (cell, row) => _(
                                                        <div className="text-nowrap text-center">{cell}<br/><small
                                                            hidden={!isFinite(cell * 100 / row.cells[11].data)}>{Math.round(cell * 100 / row.cells[11].data)} %</small>
                                                        </div>
                                                    ),
                                                    width: '50px'
                                                }
                                            ]}
                                            style={{table: {'white-space': 'nowrap'}}}
                                            resizable={true}
                                            search={false}
                                            sort={true}
                                            pagination={{enabled: false, limit: 10}}
                                            language={{
                                                'search': {
                                                    'placeholder': '🔍 Cerca...'
                                                },
                                                'pagination': {
                                                    'previous': 'Indietro',
                                                    'next': 'Avanti',
                                                    'showing': 'Stai visualizzando da',
                                                    'results': 'consulenti',
                                                    'to': 'a',
                                                    'of': 'di',
                                                },
                                                'noRecordsFound': 'Nessun consulente trovato',
                                                'error': 'Si è verificato un errore non previsto',
                                            }}
                                        />}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row> : null}
                        {(Utils.getUserData().role === "ADMIN") ? <Row>
                            <Col>
                                <Card>
                                    <CardHeader>
                                        {(loadingModules) ? <Skeleton height={20}/> : <h5>Leads Convertiti: <strong
                                            className="text-success">{totLeadsConverted}</strong> su <strong>{totLeads}</strong>
                                            <span
                                                hidden={!isFinite(Math.round(totLeadsConverted * 100 / totLeads))}>({Math.round(totLeadsConverted * 100 / totLeads)} %)</span>
                                        </h5>}
                                    </CardHeader>
                                    <CardBody>
                                        {(loadingModules) ? <div className="mt-1">
                                            <Skeleton height={50}/><br/>
                                            <Skeleton height={50}/><br/>
                                            <Skeleton height={50}/><br/>
                                            <Skeleton height={50}/><br/>
                                            <Skeleton height={50}/>
                                        </div> : <div className='gridjs gridjs-container'>
                                            <div className='gridjs-wrapper'>
                                                <table role="grid" className="gridjs-table">
                                                    <thead className="gridjs-thead">
                                                    <tr className="gridjs-tr">
                                                        <th className="gridjs-th">
                                                            Provenienza
                                                        </th>
                                                        <th className="gridjs-th">
                                                            Risultati
                                                        </th>
                                                        <th className="gridjs-th">
                                                            Moduli
                                                        </th>
                                                    </tr>
                                                    {modules.map((referral, i) => {
                                                        return <tr className="gridjs-tr" key={i}>
                                                            <td className="gridjs-td text-primary text-nowrap">
                                                                <h5>{(referral.name === "TIK TOK") ? <img src={logoTikTok} alt={"tik tok"} width="20px"/> : <i className={referral.icon}/>} {referral.name}
                                                                </h5>
                                                            </td>
                                                            <td className="gridjs-td text-primary text-nowrap">
                                                                <h6>
                                                                    <strong><i className="align-middle mdi mdi-cash-check"></i> <span className="text-success">{referral.converted}</span> / {referral.quantity}
                                                                        <span hidden={!isFinite(Math.round(referral.converted * 100 / referral.quantity))}>({Math.round(referral.converted * 100 / referral.quantity)} %)</span></strong>
                                                                </h6>
                                                                <h6>
                                                                    <strong><i className="align-middle mdi mdi-calendar-check"></i> <span className="text-success">{referral.appointmentsConverted}</span> / {referral.appointments}
                                                                        <span hidden={!isFinite(Math.round(referral.appointmentsConverted * 100 / referral.appointments))}>({Math.round(referral.appointmentsConverted * 100 / referral.appointments)} %)</span></strong>
                                                                </h6>
                                                            </td>
                                                            <td className="gridjs-td text-nowrap">
                                                                {referral.modules.sort((a, b) => b.quantity - a.quantity).map((module, d) => {
                                                                    return <span key={i + "-" + d}>
                                                                        <h6>{module.name}</h6>
                                                                        <h6><i className="align-middle mdi mdi-cash-check"></i> <strong>{module.converted} su {module.quantity}</strong>&nbsp;
                                                                            <span className={"badge badge-soft-success"}> <span hidden={!isFinite(Math.round(module.converted * 100 / module.quantity))}>{Math.round(module.converted * 100 / module.quantity)} %</span></span>
                                                                        </h6>
                                                                        <h6><i className="align-middle mdi mdi-calendar-check"></i> <strong>{module.appointmentsConverted} su {module.appointments}</strong>&nbsp;
                                                                            <span className={"badge badge-soft-success"}> <span hidden={!isFinite(Math.round(module.appointmentsConverted * 100 / module.appointments))}>{Math.round(module.appointmentsConverted * 100 / module.appointments)} %</span></span>
                                                                        </h6>
                                                                        <br />
                                                                    </span>
                                                                })}
                                                            </td>
                                                        </tr>
                                                    })}
                                                    </thead>
                                                </table>
                                            </div>
                                        </div>}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row> : null}
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Dashboard;
